// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__sR6Ub","content":"GlobalSearch_content__1CnXM"};